// removed by extract-text-webpack-plugin
module.exports = {"counterContainer":"_2RzUQP_rIJG7B3K2LzRJ_c","counter":"_1eNDAzAkyhsehLRIf6K5DT"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/sharedComponents/css/counter.css
// module id = 1047
// module chunks = 0